<template>
  <div class="adminAssignStudentsPopUp">
    <div class="row" style="width: 100%">
      <div class="col-sm-3 headerText">Student Name</div>
      <div class="col-sm-3 headerText">Date Added</div>
      <div class="col-sm-3 headerText">Program</div>
    </div>
    <div
      class="row"
      style="width: 100%"
      v-for="student of students"
      v-bind:key="student.id"
    >
      <div class="col-sm-3 noWrap">
        {{ student.firstName }} {{ student.lastName }}
      </div>
      <div class="col-sm-3">
        {{
          student.activeStudent.startDate.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })
        }}
      </div>
      <div class="col-sm-3">Program</div>
      <div class="col-sm-3 text-center">
        <button class="assignWrapper" @click="toggleAssignModal(student)">
          Assign
        </button>
      </div>
    </div>
    <assign-student-to-class-modal
      :is-visible="openAssignModal"
      :student="selectedStudent"
      :classes="classes"
      @close="toggleAssignModal"
      @new="openNewClass"
      @assign="assignStudentToClass"
    ></assign-student-to-class-modal>
  </div>
</template>
<script>
import assignStudentToClassModal from "./AssignStudentToClassModal.vue";
export default {
  name: "AdminAssignStudentsPopUp",
  components: {
    assignStudentToClassModal,
  },
  props: {
    students: {
      type: Array,
      required: true,
    },
    classes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedStudent: {},
      openAssignModal: false,
    };
  },
  methods: {
    toggleAssignModal(student) {
      if (student) {
        this.selectedStudent = student;
        this.$nextTick(() => {
          this.openAssignModal = true;
        });
      } else {
        this.openAssignModal = false;
        this.$nextTick(() => {
          this.selectedStudent = {};
        });
      }
    },
    openNewClass() {
      this.$emit("new");
    },
    assignStudentToClass(payload) {
      this.$emit("assign", payload);
    },
  },
};
</script>
<style scoped>
.noWrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.headerText {
  color: rgba(64, 64, 64, 0.5);
}
.assignWrapper {
  border-radius: 5px;
  background-color: #3171e2;
  padding: 8px 20px;
  text-align: center;
  font-size: 15px;
  color: #fff;
}
.adminAssignStudentsPopUp {
  width: 100%;
  position: relative;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 15px 20px;
  box-sizing: border-box;
  gap: 10px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
